import React from 'react';
import WebModal from '../Modal';
import BottomDrawer from '../BottomDrawer';
import UpdataContent from './updataContent';
import { useTranslation } from 'react-i18next';
import { isMobile } from '@/biz/tool';
import { useIsMobileMd } from '@/hooks/useIsMobileMd';
import type { CreatorAudienceUploadTarget } from '@/biz/multiPlatformCollaboration/audience';

interface Props {
  showModalUpdataAudience: boolean;
  setShowModalUpdataAudience: (showModalUpdataAudience: boolean) => void;
  uploadCallback: () => void;
  platform?: string;
  audienceTarget?: CreatorAudienceUploadTarget;
}

const ModalUpdataAudience: React.FC<Props> = ({
  showModalUpdataAudience,
  setShowModalUpdataAudience,
  uploadCallback,
  platform,
  audienceTarget
}) => {
  const { t } = useTranslation();
  const isMobileViewport = useIsMobileMd();
  const isMobileLayout = isMobile() || isMobileViewport;

  const title = t(
    'modal.modal_take_order.audience_demographics.share_audience_insights',
    { defaultValue: 'Share audience insights' }
  );

  const handleClose = () => setShowModalUpdataAudience(false);

  const content = (
    <UpdataContent
      onClose={() => {
        setShowModalUpdataAudience(false);
      }}
      onSuccess={uploadCallback}
      platform={platform}
      audienceTarget={audienceTarget}
    />
  );

  return (
    <>
      {isMobileLayout ? (
        <BottomDrawer
          rootClassName="!z-[10010]"
          title={<div className="mt-3 text-lg font-semibold">{title}</div>}
          visible={showModalUpdataAudience}
          handleClose={handleClose}
          isShowFooter={false}
        >
          <div className="flex flex-col overflow-y-auto">{content}</div>
        </BottomDrawer>
      ) : (
        <WebModal
          modalStyle={{ zIndex: 10010 }}
          visible={showModalUpdataAudience}
          title={<div className="text-2xl font-semibold">{title}</div>}
          isShowFooter={false}
          disablePortal={false}
          canClose={true}
          handleClose={handleClose}
          width={820}
          className="!z-[10010] !items-stretch !justify-start !overflow-hidden [&>div:first-child]:!shrink-0"
          style={{
            maxHeight: 'calc(100vh - 48px)',
            maxWidth: 'calc(100vw - 48px)'
          }}
        >
          {content}
        </WebModal>
      )}
    </>
  );
};

export default ModalUpdataAudience;
